import { render, staticRenderFns } from "./KasdaTransactionContent.vue?vue&type=template&id=c24c499a&lang=pug"
import script from "./KasdaTransactionContent.vue?vue&type=script&lang=js"
export * from "./KasdaTransactionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports